import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState, useEffect } from "react";
function Article3() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView)
    {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
        img2.className = '';
        var img3 = document.getElementById("img3");
        img3.className = '';
      return "";
    }
      
    else if (secondInView)
    {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';
        var img3 = document.getElementById("img3");
        img3.className = '';
      return "";
    }
    else if (thirdInView){
      var img1 = document.getElementById("img1");
      img1.className = '';
        var img2 = document.getElementById("img2");
        img2.className = '';
        var img3 = document.getElementById("img3");
        img3.className = 'active';
      return "";
    }
  };

  const textAnimate={
    offscreen:{y:10, opacity:0},
    onscreen:{y:0,
    opacity:1,
    transition: {type:"spring",
    bounce:0.25,
    duration:0.5}}
  }
  const imgAnimate={
    offscreen:{ opacity:0},
    onscreen:{ opacity:1,
    transition: {type:"spring",
    bounce:0.25,
    delay: 0.5,
    duration:0.5}}
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article4');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article2');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
      initial={"offscreen"}
      whileInView={"onscreen"}
      viewport={{once:false, amount:0.5}}
      transition={{staggerChildren:0.25}}
      className="magazine-wrap article-wrap"
      >
        <motion.div
        variants={imgAnimate} 
        className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article3-left-img1.jpg" )}  />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article3-left-img2.jpg")}  />
          <img id="img3" className={getAnimationClass()} src={require("../../Images/article3-left-img3.jpg")}  />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article3-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div 
          variants={textAnimate} 
          className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
              </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <div
                variants={textAnimate}
              >
                <h4 className="mt-0 mb-0 pb-2 f-lora-i">A weekend exploring the</h4>
                <h1 className="fs-xl fw-light mt-0 pt-2 mb-3 f-lora text-purple">CAIRNGORMS</h1>
                <h4 className="mt-0 mb-4 pb-2 f-lora-i">a local's guide</h4>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Polly Cameron, Nethy Bridge resident and owner of The Dell of Abernethy, offers her insight into the area's top attractions, activities, food and drinks. With advice on what to see and do, this guide provides a local's perspective on exploring the Cairngorms.</p>
              </div>
              <div className="row mb-4 mb-sm-5 pb-3">
                <div className="col-sm-7">
                  <div
                  variants={textAnimate}
                  >
                    <h4 className="pt-2 mb-2">meet your local guide.</h4>
                    <h1 className="text-purple mb-4 mb-sm-5 f-lora">Polly <br/>Cameron</h1>
                  </div>
                  <p className="fw-semibold" variants={textAnimate}>How long have you lived in Nethy Bridge and what brought you here?</p>
                  <p className="" variants={textAnimate}>The Dell has been in the family since the 1960s, operated and deeply loved by my grandparents first and then my uncle John. Twelve years ago the timing was just right for all of us when my uncle was looking to move on and we were looking for a new project and a different lifestyle that would create a little space for a family. I spent every holiday here as a kid so it was very much like coming home. </p>
                </div>
                <div className="col-sm-5">
                  <img className="img-fluid"
                    src={require("../../Images/article3-right-img1.jpg")}
                  />
                </div>
              </div>
              

            </div>
            
            <div className="" ref={secondContainer}>
              <p className=" text-gold" variants={textAnimate}>What is it that you particularly enjoy about this part of Scotland?</p>
              <p className="" variants={textAnimate}>I am very grateful for our easy access to truly wild landscapes and all the pleasure and real therapy that this can offer. Quiet places where your ears ring in silence, loch dipping with just the birds for company or staring down a deer in the woods. Also, community is a huge part of living in this neck of the woods and I feel it's never been so strong following the last few years. It feels vibrant and exciting and full of possibilities.</p>

              <p className=" text-gold" variants={textAnimate}>What advice would you give to anyone looking to explore the Cairngorms?</p>
              <p className="" variants={textAnimate}>Slow it down and take your time. Life can be busy and noisy and relentless. I would first suggest finding a very quiet spot; put your feet in the water, breathe deeply in the woods, get in sync with your surroundings. </p>
              <p className="" variants={textAnimate}>Consider covering the ground on foot or by bike rather than car; this gives a great pace to experience the landscape better. With endless trails and wonderful e-bike hire options around you can cover great distances with ease. Don't over-programme your time. </p>

              <p className=" text-gold mb-4" variants={textAnimate}>Can you give us a rundown on what the Cairngorms is like as the seasons change, and in your opinion when is the best time to visit? </p>
              <p className="mb-4" variants={textAnimate}>The Cairngorms are breathtaking in any season. Spring always feels like a welcomed lengthening of day with budding trees after the dark snowy months. Early summer is filled with calm warmer days, where the lochs are warming up and the swallows return. Autumn has to be my favourite time around The Dell as the huge deciduous trees start to turn. Although famed for the Caledonian Pine forests, there are also some incredible pockets of birch and beech in this area and at this time of year the air is crisp and the colours are on fire. There is always great excitement at the first snowfall of winter as we welcome the cosy nights, huge skies full of stars and the buzz that surrounds the winter sports season in this area. </p>

              <img
                src={require("../../Images/article3-right-img2.jpg")}
                className={"w-100 mb-0"}
                alt=""
              />
              <div className="bg-green px-3 py-4 mb-4 mb-sm-5">
                <h3 className="mb-4 text-white" variants={textAnimate}>How would you spend your ideal weekend in the Cairngorms? </h3>
                <h4 variants={textAnimate} className="mb-4 fs-md text-white">Saturday</h4>
                <p className="" variants={textAnimate}>My ideal weekend would start with a bike ride through the woods with my boys, down to the <span className="text-white">Nethy House Café</span> for breakfast and some good strong coffee.</p>
                <p className="" variants={textAnimate}>I'd then pick up something for Sunday roasting from the <span className="text-white">Balliefurth Farm Shop</span> next door.</p>
                <p className="" variants={textAnimate}>Usually with a little more time, I would take the chance to travel a little further afield for a good swimming spot, either in the <span className="text-white">River Feshie</span> or <span className="text-white">Pattack Falls</span> near Laggan.</p>
                <p className="" variants={textAnimate}>Stopping in at <span className="text-white">Anderson's</span> in <span className="text-white">Boat of Garten</span> to pick up some pizzas on the way home to share ideally around a fire with friends.</p>

                  
                <h4 variants={textAnimate} className="mb-4 fs-md text-white">Sunday</h4>
                <p className="" variants={textAnimate}>We love a quiet, slow start to a Sunday. Once the roast is in, staying close to home, we'd get out into the woods surrounding The Dell. We have a huge area of ancient Caledonian pine forests right on the doorstep and <span className="text-white">Explore Abernethy</span> have mapped out a wonderful network of trails, so you are never stuck for options.</p>
                <p className="mb-1" variants={textAnimate}>After a long walk, a roast would be shared with family and I would try to squeeze in a swim at dusk nearby </p>
              </div>
              <h3 className="mb-3">plan your weekend with</h3>
              <h1 className="fs-xl fw-light text-gold f-lora mb-4">Polly's Top Picks</h1>

              <div className="row py-2 py-sm-5 mb-4 mb-sm-5">
                <div className="col-sm-4">
                  <h4 className="mt-0 mb-2 pb-2 text-purple f-lora fs-md">Eat ~ daytime.</h4>
                  <h5 className="mb-3 text-gold f-lora">The High Street Merchants</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Grantown-on-Spey <br/>Buzzing café with super healthy “buddah bowls”</p>

                  <h5 className="mb-3 text-gold f-lora">KJ's Bothy Bakery</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Grantown-on-Spey <br/>The perfect spot to grab a hearty picnic lunch.</p>

                  <h5 className="mb-3 text-gold f-lora">Nethy House Café</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Nethy Bridge <br/>Dog friendly lunch spot.</p>

                  <h5 className="mb-3 text-gold f-lora">Alvie Forest Food & Cabin Coffee</h5>
                  <p className="mb-3" variants={textAnimate}>Dalraddy Caravan Park <br/>You have to check out this food truck duo of dreams.</p>

                  <h4 className="mt-0 mb-2 pb-2 text-purple f-lora fs-md">Eat ~ evening.</h4>
                  <h5 className="mb-3 text-gold f-lora">The Old Bridge Inn</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Aviemore <br/>Log fires, great food, dogs and live music. The perfect pub.</p>

                  <h5 className="mb-3 text-gold f-lora">Osteria</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Boat of Garten <br/>The ideal blend of incredible pizza and passionate, seasonal menus.</p>

                  <h5 className="mb-3 text-gold f-lora">Tarmachan Café</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Crathie <br/>An incredible drive rewarded with a little roadside haven of fresh, local food put together with love.</p>
                </div>
                <div className="col-sm-4">
                  <h4 className="mt-0 mb-2 pb-2 text-purple f-lora fs-md">Drink.</h4>
                  <h5 className="mb-3 text-gold f-lora">The Old Bridge Inn</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Don't miss their annual summer solstice party in June.</p>

                  <h5 className="mb-3 text-gold f-lora">Inshriach Gin Distillery</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>By appointment only. The best gin around and they often have open nights with live music and dancing in the farmyard.</p>

                  <h5 className="mb-3 text-gold f-lora">The Copper Dog</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Located in the Craigellachie Hotel, you will find this great cocktail bar and whisky room.</p>

                  <h4 className="mt-0 mb-2 pb-2 text-purple f-lora fs-md">Relax.</h4>
                  <h5 className="mb-3 text-gold f-lora">Katie White Yoga</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Available throughout the valley, classes are the perfect mix of inspirational theory, dynamic flow and great tunes. Katie also hosts weekly classes and regular day retreats at The Dell.</p>

                  <h5 className="mb-3 text-gold f-lora">Jump in!</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>I'm a huge advocate of the health and relaxation that can be found following a good, cold dip and there are many lochs to choose from and local swimming groups to chum in with. Follow Wild Swim Scotland for any tips.</p>

                  <h5 className="mb-3 text-gold f-lora">Soundscape</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Guided walking meditation with a carefully curated soundtrack in the woods surrounding The Dell.</p>
                </div>
                <div className="col-sm-4">
                  <h5 className="mb-3 text-gold f-lora">Carrie Wilde Massage</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Carrie offers a blend of treatments, yoga and massage at The Dell or Killiehuntly.</p>

                  <h4 className="mt-0 mb-2 pb-2 text-purple f-lora fs-md">Shop.</h4>
                  <h5 className="mb-3 text-gold f-lora">The Bookmark</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Grantown-on-Spey <br/>Packed to the rafters, this tiny independent bookshop is a real institution. Marjory is so engaging with kids and she'll always find what you didn't even realise you were looking for.</p>

                  <h5 className="mb-3 text-gold f-lora">The Whisky Castle</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Tomintoul <br/>A dizzying selection of malts and a generous samples bar.</p>

                  <h5 className="mb-3 text-gold f-lora">Fiona's Wholefoods</h5>
                  <p className="mb-4 mb-sm-5" variants={textAnimate}>Grantown-on-Spey <br/>Refills and health food shop with the best hot chocolate in town.</p>

                  <div className="bg-green px-3 py-4">
                    <h4 className="mt-0 mb-2 pb-2 text-white f-lora fs-md">at The Dell.</h4>
                    <h5 className="mb-3 text-white f-lora">The Dell Tipi Supper Club</h5>
                    <p className="mb-4 mb-sm-5" variants={textAnimate}>A night to remember with long table dining, new pals and acoustic musical interludes.</p>

                    <h5 className="mb-3 text-white f-lora">The Dell Grocer</h5>
                    <p className="mb-2" variants={textAnimate}>We now have our own little Grocer with all our favourite things stocked for guests and the community to enjoy.</p>
                  </div>
                </div>
              </div>



              <img
                src={require("../../Images/article3-right-img3.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pb-1 pb-sm-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article3-right-img4.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article3-right-img5.jpg")}
                  />
                </div>
              </div>
            </div>
            <div className="" ref={thirdContainer}>

              <img
                src={require("../../Images/article3-right-img7.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              
              <img
                src={require("../../Images/article3-right-img8.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />

                <div className="row mb-4 mb-sm-5">
                  <div variants={textAnimate} className="col-sm-6">
                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Explore.</h4>
                    <p className="mb-1 text-gold">Anagach Woods</p>
                    <p className=" mb-4">Particularly in autumn, this is a stunning beech forest bordering the River Spey.</p>

                    <p className="mb-1 text-gold">Uath Lochans viewpoint</p>
                    <p className=" mb-4">I think this may be one of the most beautiful viewpoints in the valley and an easy climb for all the family.</p>

                    <p className="mb-1 text-gold">Ryvoan Circuit from Abernethy Forest</p>
                    <p className=" mb-4">You can walk from The Dell to the top of Cairngorm without
                    having to cross a road and this walk takes you some of the
                    way, taking in some huge views and then looping back
                    through the forest.</p>

                    <p className="mb-1 text-gold">Nethy Bridge - Kings Road & riverside path loop</p>
                    <p className=" mb-4">This loop is a great track, good on a bike or with a buggy,
                    and you can take a pit stop at the Nethy House Café or
                    village play park on the way.</p>
                  </div>
                  <div variants={textAnimate} className="col-sm-6">
                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Activities.</h4>
                    <p className="mb-1 text-gold">The Third Aye</p>
                    <p className=" mb-4">Make your own jewellery with The Third Aye in her gorgeous garden studio at Nethy Bridge.</p>

                    <p className="mb-1 text-gold">Cairngorm Reindeer Herd</p>
                    <p className=" mb-4">Visit and feed Britain’s only free-ranging herd of reindeer on the hill in winter.</p>

                    <p className="mb-1 text-gold">Tour of The Cairn Distillery</p>
                    <p className=" mb-4">Really progressive and passionate new distillery experience with lovely food offerings.</p>

                    <p className="mb-1 text-gold">Strathspey Steam Railway</p>
                    <p className=" mb-4">Upgrade to a first class cabin for afternoon high tea.</p>

                    <p className="mb-1 text-gold">Lynbreck Croft</p>
                    <p className=" mb-4">Take a tour of this authentic working Scottish croft.</p>
                  </div>
                </div>
                <div className="py-3">
                  <div className="row mb-4 mb-sm-5 align-items-center">
                    <div className="col-sm-6">
                      <h3 className="mb-3 fw-normal">and don't forget</h3>
                      <h1 className="fs-xl fw-light text-gold f-lora mb-4 mb-sm-5">Polly's <br/>Top Tips</h1>
                      <h3 className="mb-0 pb-2 text-purple f-lora">“Put your feet in the water, breathe deeply in the woods, get in sync with your surroundings.”</h3>

                    </div>
                    <div className="col-sm-6 text-end">
                      <img width={350} className="img-fluid"
                          src={require("../../Images/article3-right-img9.jpg")}
                        />
                    </div>
                  </div>
                </div>
                
                <div className="row mb-4 mb-sm-5">
                  <div variants={textAnimate} className="col-sm-6">
                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Tip 1.</h4>
                    <p className=" mb-4">Try when you can to support the area’s independent
                    retailers, of which there are plenty. You’ll find incredible
                    bread and bakes from KJ’s and fresh fruit and veg from the
                    Dairy, both in Grantown. The freshest seafood from Pro Fish
                    in Aviemore and meat from Balliefurth Farm Shop. You won’t
                    be disappointed.</p>

                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Tip 2.</h4>
                    <p className=" mb-4">Get up early! Some of the most beautiful skies, peaceful lochs and amazing displays of wildlife can be found at dawn.</p>

                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Tip 3.</h4>
                    <p className=" mb-4">Don’t underestimate the volume of people that visit the Cairngorms during the school holidays. Book in good time for bike hire, dinner reservations and activities.</p>
                  </div>
                  <div variants={textAnimate} className="col-sm-6">
                    <h4 className="mb-4 fs-md mb-3 text-purple f-lora">Must not miss!</h4>
                    <p className=" text-gold">Whisky Food Safari with Ghillie Basan</p>
                    <p className=" mb-4 pb-4">If you’re looking for a truly unique activity that just
                    encompasses this area completely, this is the one. Ghillie
                    welcomes you to her home in the hills where you prepare
                    an incredible tasting menu together to match her dizzying
                    supply of rare whiskies. The landscape, the company and
                    the flavour is the best you’ll find.</p>
                    <hr className="mt-5" />
                    <p className="mb-4 f-lora font-italic">Follow The Dell of Abernethy on Instagram to keep up to date with events and what’s going on in the area. Nothing beats a local’s recommendation!</p>
                    <p className="mb-4 f-lora font-italic">@dellofabernethy <br/>thedellofabernethy.co.uk</p>
                  </div>
                </div>
                

                
              
            </div>

          </div>
          
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article3;
